import pageContext from 'salvo-lite/context'
import Wow from './components/Wow'
import ChangeClass from './components/ChangeClass'
import Select from './components/Select'
import Slick from './components/Slick'
import Preload from './components/Preload'
import ExternalLinks from './components/ExternalLinks'
import Header from './components/Header'
import LoadMore from './components/LoadMore'
import SortBy from './components/SortBy'
import Sticky from './components/Sticky'
import SideCart from './components/SideCart'
import Variants from './components/Variants'
import Collab from './components/Collab'
import ScrollTo from './components/ScrollTo'
import Masonry from './components/Masonry'
import Video from './components/Video'
import Article from './components/Article'
import SearchForm from './components/SearchForm'
import ReadMore from './components/ReadMore'
import QuickBuy from './components/QuickBuy'
import Audio from './components/Audio'
import MenuImageHover from './components/MenuImageHover'

import Addresses from './pages/Addresses'
import Login from './pages/Login'
import Product from './pages/Product'
import Cart from './pages/Cart'

const components = {
    'wow': Wow,
    'change-class': ChangeClass,
    'select': Select,
    'slick': Slick,
    'preloader': Preload,
    'external-links': ExternalLinks,
    'header': Header,
    'load-more': LoadMore,
    'sort-by': SortBy,
    'sticky': Sticky,
    'side-cart': SideCart,
    'variants': Variants,
    'collab': Collab,
    'scroll-to': ScrollTo,
    'masonry': Masonry,
    'video': Video,
    'article': Article,
    'search-form': SearchForm,
    'read-more': ReadMore,
    'quick-buy': QuickBuy,
    'audio': Audio,
    'menu-image-hover': MenuImageHover
}

const pages = {
    'customers/addresses': Addresses,
    'customers/login': Login,
    'product': Product,
    'cart': Cart
}

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach
}

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}
    }

    registerComponents (container = document) {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = container.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }
}

export default Theme



// WEBPACK FOOTER //
// ./src/resources/scripts/Theme.js